import styled from '@emotion/styled'
import { faMars, faQuestion, faVenus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

type Props = {
  onChange: (selectedIndex: 0 | 1 | 2) => void // 0男 1女 2？
  val: 0 | 1 | 2
}

export const SexSelector: React.FC<Props> = ({ onChange, val }) => {
  return (
    <Container>
      <Item
        onClick={() => {
          onChange(0)
        }}
        selected={val === 0}
      >
        <FontAwesomeIcon icon={faMars} color="#56CCF2" size="1x" />
      </Item>
      <Item
        onClick={() => {
          onChange(1)
        }}
        selected={val === 1}
      >
        <FontAwesomeIcon icon={faVenus} color="#FFA4BC" size="1x" />
      </Item>
      <Item
        onClick={() => {
          onChange(2)
        }}
        selected={val === 2}
      >
        <FontAwesomeIcon icon={faQuestion} color="#E1E9D1" size="1x" />
      </Item>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  border: 3px solid #b7d7ea;
  background-color: #fff;
  border-radius: 4px;
  width: 100%;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Item = styled.div<{ selected: boolean }>`
  width: 44px;
  height: 44px;
  border: 8px solid ${({ selected }) => (selected ? '#b7d7ea' : 'transparent')};
  background-color: transparent;
  border-radius: 4px;
  padding: 8px;
`
